<script setup lang="ts">
import { SplideSlide } from '@splidejs/vue-splide'

defineProps<{
  title?: string
  subtitle?: string
  items: {
    title: string
    text: StoryBlokRichText
    title2?: string
    text2?: StoryBlokRichText
  }[]
}>()
const sliderOptions = {
  type: 'loop',
  fixedWidth: '373px',
  gap: '20px',
  perPage: 3,
  height: 'auto',
  breakpoints: {
    1160: {
      perPage: 2,
    },
    640: {
      perPage: 1,
      padding: '0px',
      fixedWidth: '335px',
      gap: '20px',
    },
    374: {
      perPage: 1,
      padding: '0px',
      fixedWidth: '280px',
      gap: '20px',
    },
  },
}
// eslint-disable-next-line prefer-const
let countItemNumber = 1
</script>

<template>
  <div class="text-center">
    <h2 class="px-5">
      {{ title }}
    </h2>
    <div class="text-xl font-bold p-5">
      {{ subtitle }}
    </div>
    <AppSlider :options="sliderOptions">
      <SplideSlide v-for="item in items" class="article-card">
        <div class="h-full flex flex-col items-stretch text-left gap-y-5">
          <div class="rounded-xl bg-white p-5 h-full overflow-hidden" :class="{ 'h-1/2': item.title2 }">
            <div class="flex items-center gap-2.5">
              <div class="min-w-30px h-30px rounded-full bg-primary text-white font-bold text-center pt-3px">
                {{ countItemNumber++ }}
              </div>
              <h4>{{ item.title }}</h4>
            </div>
            <StoryblokRichText class="page-loan-swiper" :document="item.text" />
          </div>
          <div v-if="item.title2" class="rounded-xl bg-white p-5 h-1/2">
            <div class="flex items-center gap-2.5">
              <div class="min-w-30px h-30px rounded-full bg-primary text-white font-bold text-center pt-3px">
                {{ countItemNumber++ }}
              </div>
              <h4>{{ item.title2 }}</h4>
            </div>
            <StoryblokRichText v-if="item.text2" class="page-loan-swiper" :document="item.text2" />
          </div>
        </div>
      </SplideSlide>
    </AppSlider>
  </div>
</template>

  <style lang="scss" scoped>
  .page-loan-swiper {
    :deep(p) {
      @apply mt-2.5;
    }
  }
  </style>
